import axios from "axios"
import Swal from 'sweetalert2'
const API_URL = process.env.REACT_APP_API_URL;
const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.interceptors.request.use(
  config => {
    const authUserRaw = localStorage.getItem('authUser')
    try {
      const authUser = JSON.parse(authUserRaw)
      if (authUser?.token) {
        config.headers['authorization-key'] = authUser.token
      }
      if (authUser?.id) {
        config.headers['user-id'] = authUser.id
      }
    } catch (error) {
      console.error("Failed to parse authUser from localStorage:", error)
    }
    return config
  },
  error => Promise.reject(error)
)

axiosApi.defaults.headers.common["user-service"] = 'tobacco-web-user'
axiosApi.defaults.headers.common["auth-key"] = 'tobaccoweb@2026'
// axiosApi.defaults.headers.common["Content-Type"] = 'multipart/form-data'

axiosApi.interceptors.response.use(
  response => response,
  error => {
    const { response } = error
    if (!response) {
      console.error("Network error or no response from server:", error)
      return Promise.reject({ message: "Network error. Please try again later." })
    }
    switch (response.status) {
      case 400:
        return Promise.reject({ message: "Bad request. Please check your input." })
      case 401:
        //Swal.fire({
        //  icon: 'warning',
        //  title: 'Unauthorized',
         // text: 'You are not authorized. Please login again...!',
        //  confirmButtonText: 'OK'
        //}).then(() => {
            // window.location.href = '/tobacco_demo/login'
        //})
        return Promise.reject({ message: "Unauthorized. Please login again." })
      case 403:
        return Promise.reject({ message: "You do not have permission to access this resource." })
      case 404:
        return Promise.reject({ message: "Resource not found." })
      case 500:
        return Promise.reject({ message: "Internal server error. Please try again later." })
      default:
        return Promise.reject({ message: `An error occurred. Status code: ${response.status}` })
    }
  }
)

export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while fetching data." }
  }
}
export async function post(url, data, config = {}) {
  try {
    const response = await axiosApi.post(url, data, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while posting data." }
  }
}

export async function put(url, data, config = {}) {
  try {
    const response = await axiosApi.put(url,  ...data , { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while updating data." }
  }
}

export async function del(url, config = {}) {
  try {
    const response = await axiosApi.delete(url, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while deleting data." }
  }
}


